import Vue from "vue";
import Router from "vue-router";

import qs from "qs";

// DEFAULT ROUTES
import defaultRoutes from "./default";

// SESSION COMPONENTS
const SignUpOne = () => import("Views/session/SignUpOne");
const LoginOne = () => import("Views/session/LoginOne");
const LockScreen = () => import("Views/session/LockScreen");
const ForgotPassword = () => import("Views/session/ForgotPassword");
const ResetPassword = () => import("Views/session/ResetPassword");
const UserInvite = () => import("Core/users/views/UserInvite");

Vue.use(Router);

export default new Router({
    base: "/",
    mode: "history",
    // set custom query resolver
    parseQuery(query) {
        return qs.parse(query);
    },
    stringifyQuery(query) {
        var result = qs.stringify(query, { encode: false });

        return result ? "?" + result : "";
    },
    routes: [
        defaultRoutes,
        {
            path: "/session/sign-up",
            component: SignUpOne,
            meta: {
                title: "lang.signUp",
                breadcrumb: "Session / Sign Up",
            },
        },
        {
            path: "/session/login/:redirect?",
            name: "login",
            component: LoginOne,
            meta: {
                title: "lang.login",
                breadcrumb: "Session / Login",
            },
        },
        {
            path: "/session/lock_screen",
            component: LockScreen,
            meta: {
                title: "Lock Screen",
                breadcrumb: "Session / Lock Screen",
            },
        },
        {
            name: "forgot_password",
            path: "/session/forgot_password",
            component: ForgotPassword,
            meta: {
                title: "lang.forgotPassword",
                breadcrumb: "Session / Forgot Password",
            },
        },
        {
            path: "/session/reset_password/:id",
            component: ResetPassword,
            meta: {
                title: "lang.resetPassword",
                breadcrumb: "Session / Reset Password",
            },
        },
        {
            path: "/users/user_invite/:token/:people_id",
            component: UserInvite,
            meta: {
                title: "lang.userInvite",
                breadcrumb: "Users / User Invite",
            },
        },
    ],
});
